<template>
  <div v-if="rights.includes('cashdesk')"
       class="form-narrow pt-3 pb-5">

    <SelectGroup :options="systemsAvailable"
                 v-if="systemsAvailable.length"
                 :null-option="false"
                 :label="$t('system_to_use')"
                 :showlabel="true"
                 class="mb-5"
                 v-model="cashdeskSystem"
                 @input="systemChanged"
                 variant="white"/>

    <WebkassaIntegration @update="$emit('update')"/>

    <AQSIIntegration @update="$emit('update')"/>

    <KKMIntegration @update="$emit('update')"/>

    <NewCasIntegration @update="$emit('update')"/>

    <KaspiPosIntegration @update="$emit('update')"/>

  </div>
</template>

<script setup>
import { useStore} from "vuex"
import WebkassaIntegration from "@/components/parts/cashdesk/WebkassaIntegration.vue"
import KKMIntegration from "@/components/parts/cashdesk/KKMIntegration.vue"
import AQSIIntegration from "@/components/parts/cashdesk/AQSIIntegration.vue"
import NewCasIntegration from "@/components/parts/cashdesk/NewCasIntegration.vue"
import KaspiPosIntegration from "@/components/parts/cashdesk/KaspiPosIntegration.vue"
import SelectGroup from "@/components/form/SelectGroup.vue"
import {computed, getCurrentInstance, onBeforeMount, onMounted, ref} from "vue"
import {useHead} from "@unhead/vue"
import { ClinicService } from "@/services/api/clinic.api.service"
import {openAndScrollToElement} from "@/services/integration.helper"
import {useRoute} from "vue-router"

let i18n = null
const title = ref('')
const loaded = ref(false)
const cashdeskSystem = ref(false)

const emit = defineEmits(['update'])
const store = useStore()
const route = useRoute()

useHead({
  title: () => title.value,
})

onBeforeMount(() => {
  i18n = (getCurrentInstance())?.ctx?.$i18n
  title.value = i18n.t('settings')
})

const rights = computed(() => store.state.auth.rights)
const clinic = computed(() => store.state.auth.clinic)
const superadmin = computed(() => store.state.auth.superadmin)

const systemsAvailable = computed(() => {
  const arr = []
  if (rights.value.includes('webkassa')) {
    arr.push({ id: 'webkassa', title: 'Webkassa' })
  }
  if (rights.value.includes('aqsi')) {
    arr.push({ id: 'aqsi', title: 'Aqsi' })
  }
  if (rights.value.includes('kkm')) {
    arr.push({ id: 'kkm', title: 'KKM' })
  }
  if (rights.value.includes('newcas')) {
    arr.push({ id: 'newcas', title: 'NewCas' })
  }
  if (rights.value.includes('kaspi_pos')) {
    arr.push({ id: 'kaspi_pos', title: 'Kaspi-POS' })
  }
  return arr
})

onMounted(() => {
  cashdeskSystem.value = store.getters.dynamicConfigValue('cashdeskSystem')
  loaded.value = true
  if(systemsAvailable.value.length === 1 && systemsAvailable.value[0].id !== cashdeskSystem.value) {
    cashdeskSystem.value = systemsAvailable.value[0].id
    systemChanged(cashdeskSystem.value)
  }
  openAndScrollToElement(route.query?.integration)
})

const systemChanged = async (val) => {
  await ClinicService.saveDynamicConfigs([
        { id: 'cashdeskSystem', value: val, subgroup: 'cashdesk' },
      ],
      superadmin.value, clinic.value.id)
  emit('update')
}
</script>
